import {
  Box,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

function Footer() {
  const footerBg = useColorModeValue(
    "rgba(15, 23, 42, 0.95)",
    "rgba(11, 19, 41, 0.95)"
  );
  const footerBorder = useColorModeValue("slate.800", "whiteAlpha.100");

  return (
    <Box
      as="footer"
      bg={footerBg}
      backdropFilter="blur(20px)"
      color="slate.300"
      py={8}
      mt={12}
      borderTop="1px solid"
      borderColor={footerBorder}
    >
      {/* Copyright Info */}
      <Text textAlign="center" fontSize="xs" color="slate.400" fontWeight="500">
        © {new Date().getFullYear()} Tunisian XP Database. All rights reserved.
      </Text>
    </Box>
  );
}

export default Footer;

